import React from "react";
import { MsalProvider } from "@azure/msal-react";
import type { Configuration } from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import useConfig from "@/hooks/useConfig";

export default function MsalInstanceProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const config = useConfig();

  if (!config) return children;

  const {
    msalApplicationId,
    msalInstance,
    msalRedirectUri,
    msalSignInPolicy,
    msalTenant,
  } = config;

  const signInAuthority = `${msalInstance}/${msalTenant}/${msalSignInPolicy}`;

  // MSAL configuration
  const configuration: Configuration = {
    auth: {
      clientId: msalApplicationId,
      authority: signInAuthority,
      redirectUri: msalRedirectUri,
      postLogoutRedirectUri: "/",
      knownAuthorities: [signInAuthority],
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  };

  const instance = new PublicClientApplication(configuration);
  return <MsalProvider instance={instance}>{children}</MsalProvider>;
}
